<div id="prefect-{{ student.house }}" class="text-center prefectBadge">
  <img src="assets/img/hp-house-{{ student.house }}.png" alt="{{ student.house }}" class="w-auto mx-auto h-28">
  <p class="mt-6 text-xl font-semibold">{{student.schoolclass.level }} - {{ student.child.firstname }} {{
    student.child.lastname }}
  </p>
</div>
